import ResultConversionRepository from "@/repositories/dexpara/ResultConversionRepository";
import makeStore from "@/storages/Base/Storage";

const store = makeStore('resultconversion', ResultConversionRepository);

export default {
    ...store
};